import { memo, useCallback } from 'react';

import { Search } from '@air/next-icons';

import { SearchCommandItem } from '~/components/SearchCommand/SearchCommandItem';

export type SearchCommandSuggestionListItemProps = {
  suggestion: string;
  onSelect: (suggestion: string) => void;
};

export const SearchCommandSuggestionListItem = memo(
  ({ suggestion, onSelect: _onSelect }: SearchCommandSuggestionListItemProps) => {
    const onSelect = useCallback(() => _onSelect(suggestion), [suggestion, _onSelect]);

    return (
      <SearchCommandItem data-type="suggestion" onSelect={onSelect} value={suggestion}>
        <Search className="w-4 shrink-0 text-grey-10" />

        <div className="truncate font-medium text-14">{suggestion}</div>
      </SearchCommandItem>
    );
  },
);

SearchCommandSuggestionListItem.displayName = 'SearchCommandSuggestionListItem';
